/**
 * Navigation items configuration for the main application navbar.
 * Used across different page templates to maintain consistent navigation.
 */
export const NAVIGATION_ITEMS = [
  { key: 'home', to: '/', label: 'Home' },
  { key: 'library', to: '/library', label: 'Library' },
  { key: 'explore', to: '/explore', label: 'Explore' },
] as const;

export type NavigationItem = (typeof NAVIGATION_ITEMS)[number];
